
(function () {
    'use strict';

    angular
        .module('afApp')
        .factory('AfService', AfService);

    AfService.$inject = ['$resource', 'authExpiredInterceptor', 'GLOBAL_URL'];

    function AfService($resource, authExpiredInterceptor, GLOBAL_URL) {
    	return $resource(GLOBAL_URL + 'api/e-stock/af/:uri',{uri: '@uri'}, {
    		'query':  {method: 'GET', isArray: true},
  		  	'post':   {method:'POST'}
      });
    }
})();

